import { Button } from '@shared/components/ui/button';
import { DateRangePicker } from '@shared/components/ui/DateRangePicker';
import { Label } from '@shared/components/ui/label';
import { MultiSelect } from '@shared/components/ui/MultiSelect';
import { useTranslation } from 'react-i18next';
import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import { useReturnedFilters } from '../../hooks/useReturnedFilters';

interface ReturnedFiltersPanelProps {
  initialConditions: FilterConditionOutput[];
  onChange: (conditions: FilterConditionOutput[]) => void;
}

export const ReturnedFiltersPanel = ({ initialConditions, onChange }: ReturnedFiltersPanelProps) => {
  const { t } = useTranslation('returnedModule');
  const { filters, handleFilterChange, clearFilters } = useReturnedFilters({
    initialConditions,
    onChange,
  });

  const eventOptions = [
    { label: t('filters.options.2', 'Ajuste de stock'), value: '2' },
    { label: t('filters.options.8', 'Pedido'), value: '8' },
    { label: t('filters.options.9', 'Picking'), value: '9' },
    { label: t('filters.options.13', 'Packing'), value: '13' },
  ];

  return (
    <div className="space-y-4 min-w-[300px]">
      {/* Event Type */}
      <div className="space-y-2">
        <Label>{t('filters.type', 'Tipo de evento')}</Label>
        <MultiSelect
          options={eventOptions}
          value={filters.events}
          onValueChange={(val) => handleFilterChange('events', val)}
          placeholder={t('filters.type', 'Selecciona tipo de evento')}
          variant="inverted"
        />
      </div>

      {/* Date Range */}
      <div className="space-y-2">
        <Label>{t('filters.date', 'Fecha')}</Label>
        <DateRangePicker
          date={{
            from: filters.dateFrom,
            to: filters.dateTo,
          }}
          onSelect={(range) => {
            handleFilterChange('dateFrom', range?.from);
            handleFilterChange('dateTo', range?.to);
          }}
        />
      </div>

      {/* Clear Filters Button */}
      <div className="pt-2">
        <Button
          variant="outline"
          className="w-full"
          onClick={clearFilters}
          disabled={!filters.events.length && !filters.dateFrom && !filters.dateTo}
        >
          {t('filters.clear', 'Limpiar filtros')}
        </Button>
      </div>
    </div>
  );
};
